import React from 'react';
import PropTypes from 'prop-types';

import NextLink from '../../components/NextLink';
import ServicesComponent from '../../services/components/Services';

const Services = props => (
  <div>
    <ServicesComponent {...props} />
    {props.nextLink && <NextLink to={props.nextLink} onNextClick={props.onNextClick} />}
  </div>
);
Services.propTypes = {
  nextLink: PropTypes.string,
  onNextClick: PropTypes.func.isRequired,
};
Services.defaultProps = {
  nextLink: '',
};

export default Services;



// WEBPACK FOOTER //
// ./src/app/dynamicBooking/services/Services.jsx